export default __webpack_public_path__ + "static/media/Watch Captain's Honor Shield.9cc97019.jpg";